// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("@rescript/std/lib/js/curry.js");
var React = require("react");
var Belt_Id = require("@rescript/std/lib/js/belt_Id.js");
var Util_Dom = require("../util/Util_Dom.bs.js");
var Belt_Option = require("@rescript/std/lib/js/belt_Option.js");
var Belt_MutableMap = require("@rescript/std/lib/js/belt_MutableMap.js");

function handleClickOutside(domElement, e, fn) {
  var targetElement = e.target;
  if (domElement.contains(targetElement)) {
    return ;
  } else {
    return Curry._1(fn.current, undefined);
  }
}

function cmp(a, b) {
  if (a !== b) {
    return 1;
  } else if (a === b) {
    return 0;
  } else {
    return -1;
  }
}

var RefCmp = Belt_Id.MakeComparable({
      cmp: cmp
    });

var refs = Belt_MutableMap.make(RefCmp);

function handleMouseDown(e) {
  Belt_MutableMap.forEach(refs, (function (ref, onClickOutside) {
          Belt_Option.forEach(Util_Dom.getDomRef(ref), (function (refValue) {
                  handleClickOutside(refValue, e, onClickOutside);
                }));
        }));
}

function make(ref, onClickOutside) {
  var onClickOutsideRef = React.useRef(function (param) {
        
      });
  React.useEffect((function () {
          onClickOutsideRef.current = onClickOutside;
        }), [onClickOutside]);
  React.useEffect((function () {
          if (Belt_MutableMap.isEmpty(refs)) {
            document.addEventListener("mousedown", handleMouseDown);
          }
          Belt_MutableMap.set(refs, ref, onClickOutsideRef);
          return (function (param) {
                    Belt_MutableMap.remove(refs, ref);
                    if (Belt_MutableMap.isEmpty(refs)) {
                      document.removeEventListener("mousedown", handleMouseDown);
                      return ;
                    }
                    
                  });
        }), [
        ref,
        onClickOutsideRef
      ]);
}

exports.handleClickOutside = handleClickOutside;
exports.RefCmp = RefCmp;
exports.refs = refs;
exports.handleMouseDown = handleMouseDown;
exports.make = make;
/* RefCmp Not a pure module */
